function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#ABCB0C",
  d: "M17.383.655c-.461.06-.918.137-1.368.228-.484.098-.962.213-1.433.345",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6C3C90",
  d: "M18.926.514c-.365.02-.728.049-1.087.087-.153.017-.305.035-.456.054",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FE328B",
  d: "M20 .486c-.36 0-.719.01-1.074.028",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#44BE70",
  d: "M14.64 1.212c-.378.105-.752.221-1.12.347-.794.272-1.565.592-2.31.957-.444.218-.88.452-1.305.7",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FEB70C",
  d: "M11.21 2.516c-.444.218-.88.452-1.305.7-1.527.895-2.926 1.987-4.16 3.241",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FE920F",
  d: "M5.745 6.457c-1.79 1.82-3.236 3.98-4.228 6.376C.539 15.19 0 17.775 0 20.486",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#0CB9E6",
  d: "M0 20.486c0 1.132.094 2.243.275 3.324.976 5.832 4.476 10.81 9.338 13.77",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#37549C",
  d: "M9.613 37.58c3.028 1.844 6.583 2.906 10.387 2.906 5.932 0 11.26-2.582 14.923-6.684",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#0C235C",
  d: "M34.923 33.802C38.08 30.265 40 25.6 40 20.486c0-11.046-8.954-20-20-20",
  transform: "translate(-167 -376) translate(48 336) translate(120 40.514)"
})))));

var SvgCircle = function SvgCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle.6e55a544.svg";
export { ForwardRef as ReactComponent };